import { Component, Inject, DOCUMENT } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { CoreService } from './core/core.service';
import { AppVersionService } from './core/app-version.service';
import { RouterService } from './shared/store/router/router.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  styleUrls: ['./app.component.scss'],
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  constructor(
    private readonly coreService: CoreService,
    private readonly appVersionService: AppVersionService,
    private readonly routerService: RouterService,
    private titleService: Title,
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.coreService.configure();
    this.appVersionService.start();

    this.fullscreen = this.routerService.routeFullscreenData$;

    this.translate.onLangChange.subscribe(() => {
      this.setTitle();
    });
    this.setTitle();
  }

  themes$: Observable<themes[]> = of(['default', 'easybroker']);

  selectedTheme$: BehaviorSubject<themes> = new BehaviorSubject<themes>(
    'easybroker'
  );

  loadStyle = (styleName: themes) => {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById(
      'client-theme'
    ) as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = styleName + '.css?v=' + 'x';
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}.css?v=` + 'x';
      head.appendChild(style);
    }
  };

  fullscreen: Observable<boolean>;

  title = 'easybroker';

  setTitle() {
    this.translate.get('APP_TITLE').subscribe((translatedTitle: string) => {
      this.titleService.setTitle(translatedTitle);
    });
  }
}

export type themes = 'default' | 'easybroker';
